import { gql } from "@apollo/client";

export const InstalledBaseRegionSubscriptions = gql`
    query InstalledBaseRegionSubscriptions {
        installedBaseRegionSubscriptionList {
            total
            subscriptions(pagination: { limit: 100, start: 0 }) {
                id
                inApp
                mail
                push
                iotAlert
                iotAlertSeverity
                maintenanceDue
                maintenanceSeverity
                maintenanceType
                insert
                update
                region {
                    id
                    name
                }
            }
        }
    }
`;
